// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Wifi from '../_raw/service/icon_wifi.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Wifi);
